import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScheduleAppointment = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "scheduleAppointment",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12815",
			"data-name": "Path 12815",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12816",
			"data-name": "Path 12816",
			d: "M15,3V5",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12817",
			"data-name": "Path 12817",
			d: "M7,3V5",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12818",
			"data-name": "Path 12818",
			d: "M3,8H19",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12819",
			"data-name": "Path 12819",
			d: "M19,10V6a2,2,0,0,0-2-2H5A2,2,0,0,0,3,6V17a2,2,0,0,0,2,2h6",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12820",
			"data-name": "Path 12820",
			d: "M7,10.75A.25.25,0,1,0,7.25,11,.249.249,0,0,0,7,10.75",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12821",
			"data-name": "Path 12821",
			d: "M7,14.75A.25.25,0,1,0,7.25,15,.249.249,0,0,0,7,14.75",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12822",
			"data-name": "Path 12822",
			d: "M10.75,11A.25.25,0,1,0,11,10.75a.249.249,0,0,0-.25.251",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12827",
			"data-name": "Path 12827",
			d: "M12.178,12.177c-1.538,1.539-3.488,2.52-4.647,1.366l-.281-.281a.847.847,0,0,1,.113-1.3c.274-.191.569-.4.894-.625a.855.855,0,0,1,1.091.09l.318.316a6.814,6.814,0,0,0,1.146-.932h0a6.786,6.786,0,0,0,.932-1.146l-.316-.318a.855.855,0,0,1-.09-1.091c.23-.326.435-.62.625-.894a.848.848,0,0,1,1.3-.113l.281.281c1.154,1.159.173,3.107-1.365,4.647",
			transform: "translate(6.477 5.299)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgScheduleAppointment;
